export default __webpack_public_path__ + "static/media/verified_green_24dp.eb8a8708.svg";